import React from "react";
import { Card } from "@/components/ui/card";

export function KpiCard({ label, value, sub, icon: Icon, accent = "primary", index = 0, testId }) {
  const accents = {
    primary: "text-primary bg-primary/10",
    warning: "text-warning bg-warning/10",
    danger: "text-destructive bg-destructive/10",
    secondary: "text-secondary-foreground bg-secondary/20",
  };
  return (
    <Card
      className="group relative overflow-hidden border p-5 shadow-sm transition-transform duration-200 hover:-translate-y-1"
      style={{ animation: `fadeUp 0.4s ease ${index * 60}ms both` }}
      data-testid={testId}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">{label}</p>
          <p className="font-heading text-2xl font-bold tnum">{value}</p>
          {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
        </div>
        {Icon && (
          <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${accents[accent]}`}>
            <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" />
          </div>
        )}
      </div>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </Card>
  );
}
